@import 'styles/mixins';
@import 'styles/variables';

.container {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 8px;
  border: 1px solid var(--neutral-5);
  border-radius: 16px;
  box-shadow: 0px 0px 24px 0px rgba(19, 21, 26, 0.1);
  gap: 8px;
  margin-top: 4px;
  margin-bottom: -28px;

  .promptContainer {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .promptInputContainer {
      position: relative;

      .promptInput {
        padding-right: 42px;
      }

      .submitButton {
        position: absolute;
        right: 4px;
        bottom: 10px;
      }
    }

    .promptFooter {
      @include sm-medium;
      color: var(--neutral-40);
    }
  }

  .brandVoiceContainer {
    display: flex;
    flex-direction: column;
    gap: 12px;

    .voiceLabel {
      @include sm-medium;
    }
  }
}
